import React from "react";
import { Button } from "antd";
import { SafetyOutlined, LockOutlined, ClockCircleOutlined } from "@ant-design/icons";
import "react-phone-number-input/style.css";
import ReactInputVerificationCode from "react-input-verification-code";
import PhoneInput from "react-phone-number-input";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

const formatTime = (seconds) => {
  const m = Math.floor(seconds / 60).toString().padStart(2, "0");
  const s = (seconds % 60).toString().padStart(2, "0");
  return `${m}:${s}`;
};

const Stepper = ({ step, t }) => (
  <div className={styles.stepper}>
    <div className={`${styles.step} ${step >= 1 ? styles.stepActive : ""} ${step > 1 ? styles.stepDone : ""}`}>
      <div className={styles.stepCircle}>{step > 1 ? "✓" : "1"}</div>
      <span className={styles.stepLabel}>{t("mfa_page.enter_number", "Enter Number")}</span>
    </div>
    <div className={`${styles.stepLine} ${step > 1 ? styles.stepLineDone : ""}`} />
    <div className={`${styles.step} ${step >= 2 ? styles.stepActive : ""}`}>
      <div className={styles.stepCircle}>2</div>
      <span className={styles.stepLabel}>{t("mfa_page.verify_code", "Verify Code")}</span>
    </div>
  </div>
);

const Representation = ({
  setPhonenumber,
  phonenumber,
  setVerificationCode,
  verificationCode,
  sendSMS,
  verifyCode,
  smsSent,
  timeLeft,
  resend,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapperHeader}>
      <div className={styles.shieldIcon}>
        <SafetyOutlined />
      </div>
      <h4 className={styles.wrapperTitle}>{t("mfa_page.title", "Two-Factor Authentication")}</h4>
      <p className={styles.wrapperSubtitle}>
        {smsSent
          ? t("settings.39", { phonenumber })
          : t("mfa_page.subtitle", "Add an extra layer of security to your account")}
      </p>

      <Stepper step={smsSent ? 2 : 1} t={t} />

      {smsSent ? (
        <div className={styles.customVerifyCode}>
          <p className={styles.fieldLabel}>{t("settings.37")}</p>
          <ReactInputVerificationCode
            onChange={(val) => setVerificationCode(val)}
            value={verificationCode}
            length={6}
            placeholder=""
            autoFocus="true"
          />
          <div className={styles.timerRow}>
            <ClockCircleOutlined
              className={timeLeft < 30 ? styles.timerIconWarn : styles.timerIcon}
            />
            <span className={timeLeft < 30 ? styles.timerTextWarn : styles.timerText}>
              {t("mfa_page.code_expires_in", "Code expires in")}{" "}
              <strong>{formatTime(timeLeft)}</strong>
            </span>
          </div>
        </div>
      ) : (
        <div className={styles.customPhoneInput}>
          <p className={styles.fieldLabel}>{t("settings.4")}</p>
          <PhoneInput
            placeholder={t("settings.41")}
            value={phonenumber}
            onChange={setPhonenumber}
          />
          <p className={styles.fieldHelper}>
            {t("mfa_page.sms_helper", "We'll send a 6-digit verification code via SMS")}
          </p>
        </div>
      )}

      <Button
        loading={isLoading}
        id="mfa-button"
        className={styles.btn}
        onClick={() => (smsSent ? verifyCode(true) : sendSMS())}
      >
        {smsSent
          ? t("mfa_page.verify_enable", "Verify & Enable 2FA")
          : t("settings.46")}
      </Button>

      {smsSent && (
        <div className={styles.resendRow}>
          <span className={styles.resendText}>{t("settings.42")}</span>
          {timeLeft === 0 ? (
            <button className={styles.resendBtn} onClick={resend}>
              {t("settings.43")}
            </button>
          ) : (
            <span className={styles.resendCooldown}>
              {t("mfa_page.resend_in", { time: formatTime(timeLeft), defaultValue: `Resend in ${formatTime(timeLeft)}` })}
            </span>
          )}
        </div>
      )}

      {!smsSent && (
        <p className={styles.smsCost}>{t("mfa_page.sms_rates", "Standard SMS rates may apply")}</p>
      )}

      <div className={styles.footer}>
        <LockOutlined className={styles.footerIcon} />
        <span>{t("mfa_page.encrypted_number", "Your number is encrypted and never shared")}</span>
      </div>
    </div>
  );
};

export default Representation;
